import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

const defaultMessages = defineMessages({
  unexpected: {
    id: 'error-message-unexpected',
    defaultMessage: 'Tapahtui odottamaton virhe',
  },
});

const ErrorMessage = ({ intl, code, messages }) => {
  if (code === null) return null;
  const message = messages[code] || defaultMessages.unexpected;
  return <span>{intl.formatMessage(message)}</span>;
};

ErrorMessage.propTypes = {
  intl: PropTypes.object.isRequired,
  code: PropTypes.number,
  messages: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      defaultMessage: PropTypes.string.isRequired,
    })
  ),
};

ErrorMessage.defaultProps = {
  code: null,
  messages: {},
};

export default injectIntl(ErrorMessage);
